import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { ITechnicalRequirementItem } from 'types/lot/technical-requirement-items'

type TechnicalRequirementItemInput = {
  technicalId: string
  itemId?: string
}

export const technicalRequirementItemsApi = createApi({
  reducerPath: 'technicalRequirementItems',
  baseQuery,
  endpoints: (builder) => ({
    technicalRequirementItems: builder.query<
      ITechnicalRequirementItem[],
      TechnicalRequirementItemInput
    >({
      query: ({ technicalId }) => ({
        url: `/technical-requirements/${technicalId}/items`,
      }),
    }),

    technicalRequirementItem: builder.query<
      ITechnicalRequirementItem,
      TechnicalRequirementItemInput
    >({
      query: ({ technicalId, itemId }) =>
        `/technical-requirements/${technicalId}/items/${itemId}`,
    }),

    createTechnicalRequirementItem: builder.mutation<
      ITechnicalRequirementItem,
      Partial<ITechnicalRequirementItem> & TechnicalRequirementItemInput
    >({
      query: (body) => ({
        url: `/technical-requirements/${body.technicalId}/items`,
        body,
        method: 'post',
      }),
    }),

    deleteTechnicalRequirementItem: builder.mutation<
      void,
      TechnicalRequirementItemInput
    >({
      query: ({ technicalId, itemId }) => ({
        url: `/technical-requirements/${technicalId}/items/${itemId}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useTechnicalRequirementItemsQuery,
  useTechnicalRequirementItemQuery,
  useCreateTechnicalRequirementItemMutation,
  useDeleteTechnicalRequirementItemMutation,
} = technicalRequirementItemsApi
